import { render, staticRenderFns } from "./PGA.vue?vue&type=template&id=40312ec6&"
import script from "./PGA.vue?vue&type=script&lang=js&"
export * from "./PGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports